module.exports = __webpack_public_path__ + "img/vtn.6fadb5ce.svg";